"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _BuySellInstrumentSelectComponent = _interopRequireDefault(require("./BuySellInstrumentSelectComponent"));
var _instrumentActions = require("../../../../redux/actions/instrumentActions");
var _orderEntryFormConstants = require("../../../../constants/sendOrder/orderEntryFormConstants");
var _orderEntryActions = require("../../../../redux/actions/orderEntryActions");
var _buySellActions = require("../../../../redux/actions/buySellActions");
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
var _BuySellLayoutTypes = require("../BuySell/BuySellLayoutTypes");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BuySellInstrumentSelectComponentForm = (0, _reduxForm.reduxForm)({
  form: 'buySell',
  destroyOnUnmount: false
})(_BuySellInstrumentSelectComponent["default"]);
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var dealPrices = _config["default"].RetailBuySell.dealPrices;
  var instruments = (0, _instrumentPositionSelectors.instrumentsWithProductFullNamesAndProductSymbols)(state).filter(function (instrument) {
    return Object.prototype.hasOwnProperty.call(dealPrices, instrument.Symbol);
  });
  var layoutType = ownProps.displayPricePerUnit ? _BuySellLayoutTypes.BUY_SELL_LAYOUTS.PRICE_PER_UNIT : _BuySellLayoutTypes.BUY_SELL_LAYOUTS.AMOUNT_FOR_PRICE;
  return {
    instruments: instruments,
    selectedInstrument: selectedInstrument,
    initialValues: {
      side: _orderEntryFormConstants.buyValue,
      amountRadio: 'custom',
      price: '',
      quantity: '',
      fee: '0',
      orderType: _orderEntryFormConstants.orderTypes.limit.displayName,
      responseMessage: '',
      layoutType: layoutType
    }
  };
};
var mapDispatchToProps = {
  selectInstrument: _instrumentActions.selectInstrument,
  clearForm: _orderEntryActions.clearBuySellForm,
  onInstrumentSelect: _buySellActions.onInstrumentSelect
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BuySellInstrumentSelectComponentForm);